type BillingLike = {
  street?: string | null;
  houseNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  addressType?: string | null;
  companyName?: string | null;
};

type UserLike = {
  firstName?: string | null;
  lastName?: string | null;
  billingAddress?: BillingLike | null;
};

export const isUserProfileRegistrationComplete = (
  userProfile: UserLike | null | undefined
): boolean => {
  if (!userProfile?.firstName || !userProfile.lastName) {
    return false;
  }
  const a = userProfile.billingAddress;
  if (
    !a ||
    !a.street ||
    !a.houseNumber ||
    !a.postalCode ||
    !a.city
  ) {
    return false;
  }
  if (a.addressType === 'business' && !a.companyName?.trim()) {
    return false;
  }
  return true;
};
